angular.module('zc.core')
  .config(exceptionHandler);

exceptionHandler.$inject = ['$provide'];
function exceptionHandler($provide) {
  // exceptionHandler can also be overwritten, but
  // decorating is more future proof.
  $provide.decorator('$exceptionHandler', exceptionHandlerDecorator);
}

exceptionHandlerDecorator.$inject = ['$delegate', '$injector'];
function exceptionHandlerDecorator($delegate, $injector) {
  return (exception, cause) => {
    // This executes the original functionality ($log.error)
    $delegate(exception, cause);
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/config/zc.core.exceptions.js